import { Injectable, signal } from '@angular/core';
import {
  BrandingApiResponse,
  BrandingConfig,
  applyBrandingToDocument,
  cacheBranding,
  getCachedBranding,
  clearBrandingCache,
  resetBrandingToDefault,
  mapBrandingResponse,
} from '@shared/utils/branding-runtime.utils';

export { BrandingConfig as PortalBrandingConfig };

@Injectable({ providedIn: 'root' })
export class PortalBrandingRuntimeService {
  readonly logoUrl = signal<string | null>(null);

  constructor() {
    const cached = getCachedBranding();
    if (cached) {
      applyBrandingToDocument(cached, this.logoUrl);
    }
  }

  applyFromDto(dto: BrandingApiResponse): void {
    if (this.hasBrandingValues(dto)) {
      const config = mapBrandingResponse(dto);
      applyBrandingToDocument(config, this.logoUrl);
      cacheBranding(config);
    } else {
      clearBrandingCache();
      resetBrandingToDefault(this.logoUrl);
    }
  }

  clearCache(): void {
    clearBrandingCache();
    resetBrandingToDefault(this.logoUrl);
  }

  private hasBrandingValues(response: BrandingApiResponse): boolean {
    return !!(
      response.ClientBranding_ColorPrimary ||
      response.ClientBranding_ColorSecondary ||
      response.ClientBranding_ColorAccent ||
      response.ClientBranding_LogoUrl ||
      response.ClientBranding_LogoDisplayUrl
    );
  }
}
